const VIDEO_EXTENSIONS = ["mp4", "mov", "webm", "avi", "mkv"];

export function isVideoUri(uri: string): boolean {
  try {
    const url = new URL(uri);
    const ext = url.pathname.split(".").pop()?.toLowerCase();
    return !!ext && VIDEO_EXTENSIONS.includes(ext);
  } catch {
    const path = uri.split("?")[0];
    const ext = path.split(".").pop()?.toLowerCase();
    return !!ext && VIDEO_EXTENSIONS.includes(ext);
  }
}
